import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import IconMapPin from '@/shared/icons/NewDesign/IconMapPin'
import { selectAddresses } from '../../SubscriptionForm/SubscriptionFormSelectors'
import type { StoredAddress } from './missing/types'
import type { ShellSelectOption } from './types'

const pinIcon = (size: number) => <IconMapPin size={size} />

const optionOf = (id: string, label: string, address?: StoredAddress): ShellSelectOption => {
  const street = [address?.streetNumber, address?.streetName].filter(Boolean).join(' ')
  const town = [address?.zipcode, address?.city].filter(Boolean).join(' ')

  return street ? { id, title: street, subtitle: town } : { id, title: label }
}

const useShellAddressSelect = (addressesList: string[]) => {
  const { t } = useTranslation()
  const addresses: Record<string, StoredAddress> = useSelector(selectAddresses) ?? {}

  return {
    t,
    pinIcon,
    isEmpty: !addressesList.length,
    options: Object.entries(addressesList).map(([id, label]) => optionOf(id, label, addresses[id])),
  }
}

export default useShellAddressSelect
